module.exports = __webpack_public_path__ + "static/img/t3.7dda812.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/t3.jpg
// module id = Kau7
// module chunks = 11